<ct-model *ngIf="configuration" [configuration]="configuration"></ct-model>
